import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { PortalViewId, ViewRoute } from '../../viewConfiguration';
import SalesChannelRoutes from '../RMS/SalesChannels/SalesChannelRoutes';
import { RMSModules } from '../RMS/utils/rmsModules';
import { RMSSubscriptions } from '../RMS/utils/rmsSubscriptions';
import CreateAndEditProperty from './components/CreateAndEditProperty';
import PropertiesList from './PropertiesList';
import PropertyDetails from './PropertyDetails';
import PropertyGeneralSettingsPage from './PropertyGeneralSettingsPage';
import PropertySettingsRoutes from './propertySettings.routes';

const RMSPage = lazyWithRetry(() => import('../RMS/components/RMSPage'));

type RouteParams = {
  appId?: string;
};

type Props = RouteComponentProps<RouteParams>;

const PropertiesRoutes: React.FC<React.PropsWithChildren<Props>> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="properties">
      <Switch>
        <ViewRoute
          exact
          path={`${path}`}
          viewId={PortalViewId.PropertiesList}
          render={(routeProps) => <PropertiesList {...(routeProps as any)} />}
        />
        <ViewRoute
          path={`${path}/:propertyId/sales-channel`}
          render={(routeProps) => <SalesChannelRoutes {...routeProps} />}
        />

        <ViewRoute
          exact
          path={`${path}/create`}
          render={(routeProps) => <CreateAndEditProperty {...(routeProps as any)} />}
        />
        <ViewRoute
          exact
          path={`${path}/:propertyId`}
          viewId={PortalViewId.PropertiesDetails}
          render={(routeProps) => <PropertyDetails {...(routeProps as any)} />}
        />
        <ViewRoute
          exact
          path={`${path}/:propertyId/general-settings`}
          render={(routeProps) => <PropertyGeneralSettingsPage {...(routeProps as any)} />}
        />
        <ViewRoute
          exact
          path={`${path}/:propertyId/devices`}
          render={() => (
            <LazyComponent>
              <RMSPage
                toParent="./"
                subscription={RMSSubscriptions.BASE}
                title={'Devices'}
                module={RMSModules.STATIONS}
                url={`configurations/system/${RMSModules.STATIONS}`}
                propertyIdFromUrl
              />
            </LazyComponent>
          )}
        />
        <Route path={`${path}/:propertyId`} component={PropertySettingsRoutes} />
      </Switch>
    </ErrorBoundary>
  );
};

export default PropertiesRoutes;
